var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33325 10C3.33325 5.85833 6.69159 2.5 10.8333 2.5C14.9749 2.5 18.3333 5.85833 18.3333 10C18.3333 14.1417 14.9749 17.5 10.8333 17.5C8.75825 17.5 6.89158 16.6583 5.53325 15.3L6.71658 14.1167C7.76658 15.175 9.22492 15.8333 10.8333 15.8333C14.0583 15.8333 16.6666 13.225 16.6666 10C16.6666 6.775 14.0583 4.16667 10.8333 4.16667C7.60825 4.16667 4.99992 6.775 4.99992 10H7.49992L4.13325 13.3583L4.07492 13.2417L0.833252 10H3.33325ZM9.99992 10.8333V6.66667H11.2499V10.2083L14.1666 11.9417L13.5666 12.95L9.99992 10.8333Z",
    fill: "#3A4861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestore);
export default __webpack_public_path__ + "static/media/Restore.f4155ab242e45d05f9e63708b63834a0.svg";
export { ForwardRef as ReactComponent };